import { useLingui } from '@lingui/react/macro';
import { useHelpAboutUrl } from '@web/config/urls';
import Button from 'carbon-react/lib/components/button/__next__';
import Icon from 'carbon-react/lib/components/icon';

export const HelpButton = () => {
  const { t } = useLingui();
  const helpUrl = useHelpAboutUrl();
  return (
    <Button
      variantType="subtle"
      inverse
      data-pendo-id="help"
      aria-label={t`Help`}
      onClick={() => window.open(helpUrl, '_blank', 'noopener,noreferrer')}
    >
      <Icon color="white" type="help" tooltipMessage={t`Help`} />
    </Button>
  );
};
